// extracted by mini-css-extract-plugin
export var currencyInput = "_iq-1";
export var currencySymbol = "_iq-0";